export default function updateUnreadNotificationCount(
  notificationId,
  countRequest,
  setUnreadNotifications,
) {
  const counts = countRequest;
  if (countRequest.json?.id) {
    const unreadIndex = countRequest.json.id.indexOf(notificationId);
    if (unreadIndex !== -1) {
      setUnreadNotifications((n) => n - 1);
      counts.json.id = [
        ...countRequest.json.id.slice(0, unreadIndex),
        ...countRequest.json.id.slice(unreadIndex + 1),
      ];
    }
  }
  return counts;
}
